
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/heap",
      function () {
        return require("private-next-pages/destinations/heap.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/heap"])
      });
    }
  